import { LoadingState } from "@/utils/loadingUtils"
import { defineComponent } from "vue";

const LoadingMixin = defineComponent({
  data() {
    return {
      state: LoadingState.loading
    }
  },
  methods: {
    handleError(_err: any) {
      this.state = LoadingState.error;
    },
    handleSuccess() {
      this.state = LoadingState.success;
    }
  }
})

export default LoadingMixin
